import LabServiceModel from "@/models/LabServiceModel";
import InstrumentModel from "./InstrumentModel";
import AnalysisModel from "./AnalysisModel";

export default class InstrumentTestModel extends LabServiceModel {
  modelName() {
    return 'instrument-test';
  }
  defaults() {
    return {
      id: null,
      instrument_id: null,
      analysis_id: null,
      instrument: null,
      analysis: null,
      capacity: null,
      runtime: null,
      created_at: null,
      updated_at: null,
      deleted_at: null
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      instrument_id: (val) => (this.nullStringMutator(val)),
      analysis_id: (val) => (this.nullStringMutator(val)),
      capacity: (val) => (this.nullStringMutator(val)),
      runtime: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val))
    }
  }
  validation() {
    return {}
  }
  getInstrument() {
    return this.getRelatedModel(InstrumentModel, 'instrument');
  }
  getAnalysis() {
    return this.getRelatedModel(AnalysisModel, 'analysis');
  }
}
